
<div class="container-fluid">
    <div class="row my-2" *ngFor="let filter of FilterEntries; index as i">
        <div class="col-2 align-self-center">
            {{ i == 0 ? 'Filter on:' : 'and' }}
        </div>
        <div class="col-3">
            <input class="form-control" [value]="filter.Column.DisplayName" disabled />
        </div>
        <filter-wrapper [filterType]="filter.Column.FilterType" [filterInputs]="filter.Column.FilterInputs" [(filterSettings)]="filter.FilterSettings" (filterSettingsChange)="updateFilter()" [autofocus]="false"></filter-wrapper>
        <div class="col-1">
            <button type="button" class="btn btn-danger d-block w-100" (click)="removeFilter(i)">
                <i class="fa-solid fa-xmark"></i>
            </button>
        </div>
    </div>
    <div class="row my-2">
        <div class="col-2 align-self-center">
            New filter:
        </div>
        <div class="col-3">
            <select name="new-filter-column" class="form-select" [(ngModel)]="NewFilterColumn">
                <option *ngIf="Config.AnyFieldFilterPropertyNames && Config.AnyFieldFilterPropertyNames.length" [ngValue]="AnyFieldFilterColumn">
                    Any Field
                </option>
                <option *ngFor="let col of Config.Columns | IsFilterable" [ngValue]="col">
                    {{ col.DisplayName }}
                </option>
            </select>
        </div>
        <filter-wrapper *ngIf="NewFilterColumn" [filterType]="NewFilterColumn.FilterType" [filterInputs]="NewFilterColumn.FilterInputs" [(filterSettings)]="NewFilterSettings" (filterInputComplete)="addFilter()" [autofocus]="true"></filter-wrapper>
        <div *ngIf="NewFilterColumn" class="col-1">
            <button type="button" class="btn btn-secondary d-block w-100" (click)="addFilter()">Add</button>
        </div>
    </div>
</div>